var Codec = require('io/codec');

module.exports = {
    read : function(bis) {
        return {
            path : bis.readString(),
            bytes : bis.readBytes()
        };
    },
    write : function(bos, req) {
        Codec.writeString(bos, req.path);
        Codec.writeBytes(bos, req.bytes);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/update-topic/update-topic-set-request-serialiser.js
// module id = 1714
// module chunks = 1